import { useCallback } from 'react';

import { getAccount, switchChain } from '@wagmi/core';

import { useDisconnect } from 'wagmi';

import { wagmiConfig, WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';
import displayWalletErrorToast from '@shared/helpers/displayWalletErrorToast';

const useSwitchNetworkUtil = () => {
  const { disconnectAsync } = useDisconnect();

  const switchNetworkUtil = useCallback(
    async ({
      networkId,
      catchErrors = false,
      terminateConnectionOnError = true,
    }: {
      networkId: number;
      catchErrors?: boolean;
      terminateConnectionOnError?: boolean;
    }) => {
      try {
        const { chainId } = getAccount(wagmiConfig);

        if (networkId && chainId !== networkId) {
          await switchChain(wagmiConfig, {
            chainId: chainId as WagmiConfigChain['id'],
          });
        }
      } catch (error) {
        if (terminateConnectionOnError) {
          await disconnectAsync();
        }

        if (!catchErrors) {
          throw error;
        }

        displayWalletErrorToast({ error });
      }
    },
    [disconnectAsync],
  );

  return {
    switchNetworkUtil,
  };
};

export default useSwitchNetworkUtil;
